import { subCompanyLoanCountApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_LOAN_COUNT_ACTION_TYPE = createNamedActions('subCompanyLoanCount', {
  GET_LOAN_COUNT: 'GET_LOAN_COUNT',
});

// DEV-4923 SubCompany header "Active Loans" field — lazily dispatched only when a
// configured header view includes the `loancount` field.
export const getSubCompanyLoanCountAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompanyLoanCountApi.getActiveLoanCount(params);

  return dispatch({
    type: SUB_COMPANY_LOAN_COUNT_ACTION_TYPE.GET_LOAN_COUNT,
    payload: data?.count ?? null,
  });
});
